module.exports = __webpack_public_path__ + "static/media/productIntroForm1.e703a9cc.jpg";